import { CollectibleId_Schema } from "@/services/collectibles";
import { CategoryId_Schema } from "@/services/collection/categories";
import { CollectionItemId_Schema, CollectionItemStatus_Schema } from "@/services/collection/item/collectionItemSchema";
import { ApiResponse_ImageNoId_Schema, ApiResponse_ImagesNoId_Schema } from "@/services/images";
import { MarketplaceItem_Schema } from "@/services/marketplace/item/marketplaceItemSchema";
import { AvatarUrl_Schema, UserId_Schema } from "@/services/user";
import { Nickname_Schema } from "@/services/user/profile";
import { Rating_Schema } from "@/services/user/rating";
import { NaturalNumber_Schema, WholeNumber_Schema } from "@/utilities";
import { z } from "zod";

export const PublicCollectionItem_ListItem_Schema = z
  .object({
    id: CollectionItemId_Schema,
    catalogueItemParams: z
      .object({
        label: z.string(),
        value: z.string().or(z.number()),
      })
      .array(),
    categoryId: CategoryId_Schema,
    collectible: z
      .object({
        id: CollectibleId_Schema,
        name: z.string(),
      })
      .nullable(),
    collectorAvatar: AvatarUrl_Schema,
    collectorId: UserId_Schema,
    collectorItemsCount: WholeNumber_Schema,
    collectorNickname: Nickname_Schema,
    collectorRating: Rating_Schema,
    collectorRatingsCount: WholeNumber_Schema,
    images: ApiResponse_ImagesNoId_Schema,
    likedByCurrentUser: z.boolean().nullable(), // null for not-logged users
    likesCount: WholeNumber_Schema,
    marketPlaceItem: MarketplaceItem_Schema.nullable(),
    name: z.string(),
    publishedDate: z.string(), // 2025-12-31 format expected
    status: CollectionItemStatus_Schema,
    statusList: CollectionItemStatus_Schema.array(),
  })
  .transform(({ marketPlaceItem, ...rest }) => ({
    marketplaceItem: marketPlaceItem,
    ...rest,
  }));

export const PublicCollectionItem_FromCollectible_Schema = z
  .object({
    user: z.object({
      id: UserId_Schema,
      nickname: Nickname_Schema,
      avatarUrl: z.url().nullable(),
      rating: Rating_Schema,
      ratingCount: WholeNumber_Schema,
      itemsCount: NaturalNumber_Schema, // This is total items count (not only given collectible)
    }),
    id: CollectionItemId_Schema,
    name: z.string(),
    images: ApiResponse_ImageNoId_Schema.array(),
    inCollectionCount: NaturalNumber_Schema,
  })
  .transform((response) => ({
    owner: response.user,
    id: response.id,
    name: response.name,
    quantity: response.inCollectionCount,
    images: response.images,
  }));
